module.exports = {
      id: "personalise-usage",
      viewBox: "0 0 14.128 12.555",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#personalise",
      toString: function () {
        return this.url;
      }
    }